import axios from "axios";
import { extractUserDataFromJWT, setTokenInLocalStorage } from "../_helpers/helpers";
import { LOGIN_CONFIRMED, LOGOUT, SET_ORG } from "../store/Reducers/AuthReducer";
import { SET_ORG_LIST, SET_SELECTED_ORG } from "../store/Reducers/OrgReducer";
import _ from "lodash";
import { useNavigate } from "react-router-dom";
import { getOrgList } from "./api";
export function register(data){
    data['org_name'] = data?.org_domain.replace(/.+\/\/|www.|\..+/g, '')
   return axios.post(`${process.env.REACT_APP_API_ENDPOINT}/jwt/auth/register`, data)
  // return fetch(`${process.env.REACT_APP_API_ENDPOINT}/video/auth/register`, {method: 'POST', body: JSON.stringify(data), headers})
}

export function login(data){
    return axios.post(`${process.env.REACT_APP_API_ENDPOINT}/jwt/auth/login`, data);
}

export function setSelectedOrganization(dispatch, selectedOrg) {
    localStorage.setItem("selectedOrg", JSON.stringify(selectedOrg));
    dispatch(SET_ORG({data: selectedOrg}));
}

export function getSelectedOrgFromLocalSorage(){
    let orgString = localStorage.getItem("selectedOrg");
    let org = {};
    try{
        org = JSON.parse(orgString);
    } catch(error){
        org = {};
    }
    return org;
}

export function loginConfirm(action, toast, data, dispatch, navigate) {
    
    console.log("loginConfirm called with data:", data);
    const jwt = data?.token || data?.data?.data?.jwt || data.jwt || data;
  try {
    if (!jwt) throw new Error("No valid JWT token found");

    const decodedToken = extractUserDataFromJWT(jwt);
    console.log(decodedToken, "decoded token");

    // 🔹 Normalize userData
    const userData =
      data?.data?.data?.userData || // normal login
      data?.userData ||    // SSO login
      decodedToken?.userData ||     // alternative key
      decodedToken;                 // fallback

    const isSuperAdmin =
      data?.isSuperAdmin ?? 
      data?.data?.data?.isSuperAdmin ?? 
      decodedToken?.isSuperAdmin ?? 
      false;
    
    const selectedOrg = userData?.selectedOrg || data?.org || null;
    
    // 🔹 Save to localStorage
    setTokenInLocalStorage({
      jwt,
      exp: decodedToken.exp,
      user_data: userData,
      isSuperAdmin
    });

    // 🔹 Update Redux
    dispatch(LOGIN_CONFIRMED({ token: jwt, user_data: userData, exp: decodedToken.exp, isSuperAdmin }));

    if (selectedOrg) setSelectedOrganization(dispatch, selectedOrg);
    if (action?.setSubmitting) action.setSubmitting(false);

    // 🔹 Navigation
    if (userData?.extraData?.isAllBanks) navigate('/all-banks/list');
    else if (window.location.href.includes("ngage")) navigate("/campaign/list");
    else navigate('/');

    // toast({ title: 'Logged In.', status: 'success', duration: 1000, isClosable: true });

  } catch (err) {
    console.error("Failed to process login:", err);
    // toast({ title: "Login failed", status: "error" });
    if (action?.setSubmitting) action.setSubmitting(false);
  }
}




export function getOrganization(token) {
    return axios.get(`${process.env.REACT_APP_API_ENDPOINT}/jwt/orglist`, {headers: {token: token}})
}

export function logout(dispatch, shouldLoginWithSSO = false) {
    let token = JSON.parse(localStorage.getItem("token")).jwt;
    let selectedOrg = JSON.parse(localStorage.getItem('selectedOrg')).token;
    axios.get(`${process.env.REACT_APP_API_ENDPOINT}/jwt/auth/logout?org_token=${selectedOrg}`, {headers: {token: token}})
    localStorage.removeItem("selectedOrg")
    sessionStorage.removeItem("whiteLabel")
    dispatch(LOGOUT());
    
    // Redirect to SSO URL if SSO is enabled
    if (shouldLoginWithSSO) {
        const SSO_URL = process.env.REACT_APP_REDIRECT_URL?.replace(/^["']|["']$/g, '');
        if (SSO_URL) {
            window.location.replace(SSO_URL);
            return;
        }
    }
}

export function extractSelectedOrgFromUserData(userData) {
    let org = {};
    if(!_.isEmpty(userData.selectedOrg)){
        org = userData.selectedOrg;
    }
    return org;
}

export async function extractOrgListFromUserData(userData) {
    let orgList = []
    if(!_.isEmpty(userData.orgList)){
        orgList = userData.orgList;
    }
    return orgList;
}

